type SupportedFormat = "msg" | "gzip"

export const compress = async <T>(data: T, type: SupportedFormat) => {
    const worker = new Worker(new URL("./compression.worker.js", import.meta.url))
    const output = await new Promise<Uint8Array>((resolve, reject) => {
        worker.addEventListener("message", (message) => {
            if (!message.data) reject()
            resolve(message.data)
            worker.terminate()
        })
        worker.postMessage({ data, type, mode: "pack" })
    })
    return output
}
export const decompress = async <T>(data: ArrayBuffer, type: SupportedFormat) => {
    const worker = new Worker(new URL("./compression.worker.js", import.meta.url))
    const output = await new Promise((resolve, reject) => {
        worker.addEventListener("message", (message) => {
            if (!message.data) reject()
            resolve(message.data)
            worker.terminate()
        })
        worker.postMessage({ data, type, mode: "unpack" })
    })
    return output as T
}
